/**
 * The client's snapshot of the external-write leases, shared by the toolbar chip,
 * popover, banner and apiFetch's 423 refusal toast. useExternalWrites owns the fetching.
 */
import { create } from 'zustand';
import type { ExternalWritesState } from '@shared/external-writes/wire';

export interface ExternalWritesStoreState {
  state: ExternalWritesState | 'unknown';
  lastError: string | null;
}

export const initialState: ExternalWritesStoreState = {
  state: 'unknown',
  lastError: null,
};

export const useExternalWritesStore = create<ExternalWritesStoreState>(() => ({ ...initialState }));
